import { PureComponent } from 'preact-compat'
// eslint-disable-next-line import/no-internal-modules
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import { editTitle } from '@insided/shared/services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'

interface TitleProps {
  onTitleChanged: (title: string) => void
  setIsLoading: (isLoading: boolean) => void
  title: string
  contentType: ContentType
  privateId: number
}

class Title extends PureComponent<TitleProps> {
  constructor (props: TitleProps) {
    super(props)
    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  async onChangeTitle (e: {target: HTMLInputElement}) {
    const { title, contentType, privateId, onTitleChanged, setIsLoading } = this.props
    const newTitle = e.target.value
    if (newTitle === title) {
      return
    }
    setIsLoading(true)
    try {
      await editTitle(contentType, privateId, newTitle)
      onTitleChanged(newTitle)
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { title } = this.props
    return (
      <div className='topic-info__details-item'>
        <InputGroup
          id='change-topic-title'
          title='Title'
          type='text'
          onChange={this.onChangeTitle}
          value={title}
        />
      </div>
    )
  }
}

export default Title
